<div class="header">
  <h1>Customer Visits sent to Inside Sales</h1>
  <mat-chip-list>
    <mat-chip color="primary" selected class="count-chip">{{
      dataSourceArray.length || 0
    }}</mat-chip>
  </mat-chip-list>
</div>
<div class="table-container">
  <div class="content">
    <div class="filter">
      <mat-form-field appearance="standard">
        <mat-label>Filter Customer Visits</mat-label>
        <input
          matInput
          (keyup)="filterCustomerVisits($event)"
          #input
          placeholder="ex. John Doe"
        />
      </mat-form-field>
    </div>

    <table
      mat-table
      [dataSource]="sentToInsideSalesDataSource"
      class="table"
      matSort
      fixedLayout="true"
    >
      <ng-container matColumnDef="customerVisitId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          CustomerVisit #
        </th>
        <td mat-cell *matCellDef="let customerVisit">
          {{ customerVisit.customerVisitId | slice : 0 : 8 }}
        </td>
      </ng-container>
      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
        <td mat-cell *matCellDef="let customerVisit">
          {{
            customerVisit.createdDate
              ? (customerVisit.createdDate | date : "shortDate")
              : "n/a"
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="statusName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let customerVisit">
          {{ customerVisit.statusName || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
        <td mat-cell *matCellDef="let customerVisit">
          {{ customerVisit.customerName || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="jobAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
        <td mat-cell *matCellDef="let customerVisit">
          {{ customerVisit.jobAddress || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="dispositionName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Disposition</th>
        <td mat-cell *matCellDef="let customerVisit">
          {{ customerVisit.dispositionName || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="subDispositionName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          SubDisposition
        </th>
        <td mat-cell *matCellDef="let customerVisit">
          {{ customerVisit.subDispositionName || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="dispositionNotes">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Disposition Notes
        </th>
        <td mat-cell *matCellDef="let customerVisit">
          {{ customerVisit.dispositionNotes || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="dispositionDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Disposition Date
        </th>
        <td mat-cell *matCellDef="let customerVisit">
          {{
            customerVisit.dispositionDate
              ? (customerVisit.dispositionDate | date : "shortDate")
              : "n/a"
          }}
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="sentToInsideSalesDisplayedColumns; sticky: true"
      ></tr>

      <tr class="mat-row" *matNoDataRow [ngStyle]="{ 'text-align': 'center' }">
        <td
          class="mat-cell"
          [attr.colspan]="sentToInsideSalesDisplayedColumns.length"
        >
          No matching customer visits found
        </td>
      </tr>
      <tr
        mat-row
        *matRowDef="let row; columns: sentToInsideSalesDisplayedColumns"
        (click)="goToCustomerVisit(row)"
      ></tr>
    </table>

    <div *ngIf="isLoading" class="spinner">
      <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
    </div>

    <mat-paginator
      [pageSize]="100"
      [pageSizeOptions]="[10, 50, 100, 150, 500]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
